module.exports = __webpack_public_path__ + "static/media/Follower_Button-26.6a2adfb6.png";